module.exports = __webpack_public_path__ + "8c640d0abf28ede40f4ccddb44034a6b.svg";